import React from 'react';
import { Autoplay, Controller } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import SliderCard from '../../components/ConsultancyElements/SliderCard';

const MainSliders = () => {
    const SliderData = [
        {
            id: '1',
            bg: 'images/slider/1.jpg',
            title: 'Intelligent Decision Making',
            // heading: 'Convert Business Ideas',
            heading: 'Welcome to Stusphere:',
            // mid: 'into',
            tag: 'Empowering the Future of Learning!'
            // tag: 'Great Opportunities',
        },
        {
            id: '2',
            bg: 'images/slider/2.jpg',
            title: 'Best Consultation Service',
            heading: 'Discover One Integrated educational operating system (EOS):',
            tag: 'One Stop Solutionto run academics, operations, and growth for K–12 schools',
            // heading: 'We appreciate Unique',
            // tag: 'Business Ideas',
            last: '',
        },
        {
            id: '3',
            bg: 'images/slider/3.jpg',
            title: 'Reliable & affordable solutions',
            // ptag: "The Smart Hub Powering Smarter Schools.",
            ptag01: "Uniting Classrooms — Online, Onsite, All in Stusphere.",
            ptag1: "Where Technology and Learning Converge Seamlessly.",
            ptag2: "Connecting Students, Teachers, and Classrooms Everywhere.",
            // ptag3: "Your School. Your Students. One Connected Sphere.",
            // ptag4: "Together in Learning — Wherever Schools Thrive.ptag",
            // title: 'Intelligent Decision Making',
            heading: 'The Smart Hub Powering',
            tag: 'Smarter Schools.',
        },
    ];
    return (
        <section className="main-slider pt-5">
            {/* <div className="main-slider-carousel owl-carousel owl-theme"> */}

            <Swiper
                className="main-slider-carousel owl-carousel owl-theme"
                modules={[Controller, Autoplay]}
                autoplay={{
                    delay: 500000,
                    disableOnInteraction: true,
                    speed: 1000000
                }}
                slidesPerView={1}
                loop={true}
                controller={{ inverse: true }}
                spaceBetween={5}
            >
                {
                    SliderData.map(data => <SwiperSlide><SliderCard
                        key={data.id}
                        data={data}
                    /></SwiperSlide>)
                }

            </Swiper>

            {/* </div> */}
        </section>
    );
};

export default MainSliders;